import { mutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { fetcher } from '@/lib/fetcher'
import { ENDPOINTS } from '@/query-client'
import { ConfigKeys } from '@/query/config/config-types'

export const updateConfigOptions = mutationOptions<
  API,
  AxiosError<API>,
  Partial<Record<ConfigKeys, File | string>>
>({
  meta: {
    invalidatesQuery: [['config']]
  },
  mutationFn: (data) =>
    fetcher(ENDPOINTS.CONFIG.PUT_UPDATE_CONFIG, {
      auth: true,
      body: data,
      method: 'PUT'
    })
})
